import Immutable from 'immutable';

const Content: {
  version: number
  userName: string,
  password: string
} = {
  version: 2, // version of the authentication system: 1 = old system using windows users only, 2 = new system which also has database users/okta...
  userName: '',
  password: ''
};

class Authentication extends Immutable.Record(Content) {
}

export default Authentication;
